import { AsyncState, Updater, errorAsyncState, loadingAsyncState } from 'widgets-for-react'
import { GetAlternativeCourses, GetEventTemplate, getData } from '../../../../utils/api'
import { EventTemplate } from '../../../models/Events/Events'
import { CoursePage } from '../../cmsPageState'

export interface EventAlternative {
  title: string
  url: string
}

export interface CoursePageData {
  CourseStartDateAndLocationsIntroduction: string
  CourseInCompany: boolean
  CourseHideAvailableSeats: boolean
  CourseHideSchedule: boolean
  CourseDurationOverride: string
}

export interface CourseDetailsState {
  pageData: CoursePage
  eventData: AsyncState<EventTemplate>
  alternativeEvents: AsyncState<EventAlternative[]>
}

export const initialCourseDetailsState = (slug: string, pageData: CoursePage, eventId: string | null): CourseDetailsState => ({
  pageData: pageData,
  eventData: eventId ? loadingAsyncState(() => getData<EventTemplate>(GetEventTemplate(eventId))) : errorAsyncState(404),
  alternativeEvents: loadingAsyncState(() => getData<EventAlternative[]>(GetAlternativeCourses(slug)))
})

export const CourseDetailsStateUpdaters = {
  updateEventData: (u: Updater<AsyncState<EventTemplate>>): Updater<CourseDetailsState> => s0 => ({ ...s0, eventData: u(s0.eventData) }),
  updateAlternativeEvents: (u: Updater<AsyncState<EventAlternative[]>>): Updater<CourseDetailsState> => s0 => ({ ...s0, alternativeEvents: u(s0.alternativeEvents) }),
}
